export default [
  {
    name: 'addCartItem',
    type: 'nativeFunc',
    options: {
      source: 'CartAppExtensionService',
      key: 'addCartItem',
      includeAppId: true,
    },
  },
  {
    name: 'addCartItems',
    type: 'nativeFunc',
    options: {
      source: 'CartAppExtensionService',
      key: 'addCartItems',
      includeAppId: true,
    },
  },
  {
    name: 'updateCartItemQuantity',
    type: 'nativeFunc',
    options: {
      source: 'CartAppExtensionService',
      key: 'updateCartItemQuantity',
      includeAppId: true,
    },
  },
  {
    name: 'removeCartItem',
    type: 'nativeFunc',
    options: {
      source: 'CartAppExtensionService',
      key: 'removeCartItem',
      includeAppId: true,
    },
  },
];
